import { useCallback, useState } from "react";
import { dashboardApiService } from "src/api/dashboard-api";
import { ApiResponse } from "src/types/api-response";
import { DashBoardSam, DashBoardSucKhoe, SensorDeviceModel } from "src/types/dashboardSam";

export default function useDashboardSam() {
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState<DashBoardSam | null>(null);
    const [sucKhoe, setSucKhoe] = useState<DashBoardSucKhoe | null>(null);
    const [camBien, setCamBien] = useState<SensorDeviceModel[]>([]);
    const [error, setError] = useState<string | null>(null);
    
    const getTotal = useCallback(
        async (params?: {
            skip?: number;
            take?: number;
            Status?: number;
            rowCount?: number;
            searchBy?: string[];
            orderBy?: string[];
        }): Promise<ApiResponse<DashBoardSam>> => {
            setLoading(true);
            setError(null);
            try {
                const rsp = await dashboardApiService.DashBoardSam();
                setTotal(rsp.oneItem);
                return rsp;
            } catch (err: any) {
                setError(err?.message || 'Không thể tải tổng hợp cây sâm');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [] // dependency array đúng
    );
     const getSucKhoe = useCallback(
        async (params?: {
            skip?: number;
            take?: number;
            Status?: number;
            rowCount?: number;
            searchBy?: string[];
            orderBy?: string[];
        }): Promise<ApiResponse<DashBoardSucKhoe>> => {
            setLoading(true);
            setError(null);
            try {
                const rsp = await dashboardApiService.DashBoardSucKhoe();
                setSucKhoe(rsp.oneItem);
                return rsp;
            } catch (err: any) {
                setError(err?.message || 'Không thể tải tổng hợp cây sâm');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [] // dependency array đúng
    );
    const getCamBien = useCallback(
        async (params?: {
            skip?: number;
            take?: number;
            Status?: number;
            rowCount?: number;
            searchBy?: string[];
            orderBy?: string[];
        }): Promise<ApiResponse<SensorDeviceModel>> => {
            setLoading(true);
            setError(null);
            try {
                const rsp = await dashboardApiService.DashBoardSensor();
                if(rsp.items)
                    setCamBien(rsp.items);
                return rsp;
            } catch (err: any) {
                setError(err?.message || 'Không thể tải tổng hợp cây sâm');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [] // dependency array đúng
    );
    return {
        loading,
        total,
        sucKhoe,
        camBien,
        error,
        getTotal,
        getSucKhoe,
        getCamBien,
        setCamBien
    };
}